<div class="container mx-auto px-4 py-4">
  @if (loading()) {
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      @for (item of [1,2,3,4,5,6]; track item) {
        <div class="bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-800 dark:to-gray-900 rounded-xl shadow-lg p-6 border border-blue-200 dark:border-gray-700">
          <div class="flex justify-between items-start mb-4">
            <div class="h-6 skeleton rounded w-24"></div>
            <div class="h-8 skeleton rounded w-20"></div>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <div class="text-center">
              <div class="h-4 skeleton rounded mb-1"></div>
              <div class="h-6 skeleton rounded"></div>
            </div>
            <div class="text-center">
              <div class="h-4 skeleton rounded mb-1"></div>
              <div class="h-6 skeleton rounded"></div>
            </div>
            <div class="text-center">
              <div class="h-4 skeleton rounded mb-1"></div>
              <div class="h-6 skeleton rounded"></div>
            </div>
            <div class="text-center">
              <div class="h-4 skeleton rounded mb-1"></div>
              <div class="h-6 skeleton rounded"></div>
            </div>
          </div>
        </div>
      }
    </div>
  } @else if (error()) {
    <p class="text-red-500">{{ error() }}</p>
  } @else {
    <!-- Sort Controls -->
    <div class="mb-6 bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <div class="flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <label class="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
          Sort by:
        </label>

        <!-- Mobile: dropdown -->
        <div class="sm:hidden w-full">
          <p-select
            [options]="sortOptions"
            [ngModel]="selectedSortPeriod()"
            (onChange)="selectedSortPeriod.set($event.value)"
            optionLabel="label"
            optionValue="value"
            styleClass="w-full">
          </p-select>
        </div>

        <!-- Desktop: select button -->
        <div class="hidden sm:block">
          <p-selectbutton
            [options]="sortOptions"
            [(ngModel)]="selectedSortPeriod"
            optionLabel="label"
            optionValue="value">
          </p-selectbutton>
        </div>

        @if (selectedSortPeriod() && selectedSortPeriod() !== 'trend') {
          <button
            (click)="clearSort()"
            class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors whitespace-nowrap">
            Reset
          </button>
        }
      </div>
      <p class="text-sm text-black dark:text-white mt-3">
        Each card shows the <strong>price return</strong> for that sector over the selected time window.
        <strong>Trend</strong> ranks sectors by momentum acceleration — sectors where recent gains are outpacing their longer-run average.
        The period options (1 Mo., 3 Mo., 6 Mo., YTD) rank all sectors by that period's raw return, highest first.
      </p>
    </div>

    <app-sector-list [sectors]="sectors()"></app-sector-list>
  }
</div>
